import useTranslation from "next-translate/useTranslation";
import { useEffect, useState, memo, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import classes from "./listingsPageTitle.module.css";
import { escape } from "lodash";
import NumberFormat from "react-number-format";
import { fix_type } from "pagesHelpers/ListingPagesHepler/ListingPagesHelperWrapper";
import { pluralOf } from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";

type ListingsPageTitleProps = {
  title?: string;
  h1Type?: any;
  totalListingsCount?: any;
};

function ListingsPageTitle({
  title,
  h1Type,
  totalListingsCount,
}: ListingsPageTitleProps) {
  const { t, lang } = useTranslation("annonceAchat");
  const searchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  return (
    <div
      className={classes.container}
      style={{ width: "100%", maxWidth: "808px" }}
    >
      {h1Type ? (
        <p className={classes.title}>
          {`${
            totalListingsCount
              ? totalListingsCount
                  ?.toString()
                  .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
              : 0
          } ${
            searchPayload?.type?.length === 1
              ? t(pluralOf(fix_type(searchPayload)[0]))
              : t("Immobilier")
          }`}{" "}
          <span
            style={{ fontWeight: "400" }}
            dangerouslySetInnerHTML={{
              __html: escape(`${title}`),
            }}
          ></span>
        </p>
      ) : (
        <>
          <h1 className={`${lang === "ar" ? classes.titleAr : classes.title}`}>
            {" "}
            <span>
              <span className={`${lang === "ar" ? classes.countAr : ""}`}>
                {`${
                  totalListingsCount
                    ? totalListingsCount
                        ?.toString()
                        .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                    : 0
                } `}
              </span>{" "}
              <span>
                {`
                ${
                  searchPayload?.type?.length === 1
                    ? t(pluralOf(fix_type(searchPayload)[0]))
                    : t("Biens immobiliers")
                }${searchPayload.exclusivite ? t(" exclusifs agenz") : ""}`}
              </span>{" "}
            </span>{" "}
            <span
              style={{ fontWeight: "400" }}
              dangerouslySetInnerHTML={{
                __html: escape(`${title}`),
              }}
            ></span>{" "}
          </h1>
        </>
      )}
    </div>
  );
}

export default ListingsPageTitle;
